// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zvmojjatybzjnhddwefg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2bW9qamF0eWJ6am5oZGR3ZWZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc3OTMwMzIsImV4cCI6MjA3MzM2OTAzMn0.IRiT1krfadrUfVImBiSQBh4WwrkbmiaBj9F_PLTdQj0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});